import { useAction, useAtom } from "@reatom/npm-react"

import {
    runSearchRequest,
    searchDisabledAtom,
} from "modules/PsyCatalog/common/models/searchRequest"
import { formAtom } from "modules/PsyCatalog/common/models/filterForm"

export function FiltersAction() {
    const [isSearchDisabled] = useAtom(searchDisabledAtom)
    const [form] = useAtom(formAtom)
    const search = useAction(runSearchRequest)

    return (
        <button
            className="button-search button-search-highlighted"
            onClick={() => void search(form)}
            disabled={isSearchDisabled}
        >
            Показать психологов
        </button>
    )
}
